import { render, staticRenderFns } from "./DesignBq.vue?vue&type=template&id=5cf85f38&scoped=true&"
import script from "./DesignBq.vue?vue&type=script&lang=js&"
export * from "./DesignBq.vue?vue&type=script&lang=js&"
import style0 from "./DesignBq.vue?vue&type=style&index=0&id=5cf85f38&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf85f38",
  null
  
)

export default component.exports